import * as XLSX from 'xlsx';

import { Co2QuestionsDataStructure } from '../prepare-data-for-excel-export/preparaDataToForExcelExport';

export function exportToExcel(data: Co2QuestionsDataStructure) {
  // Define the headers for the Excel sheet
  const headers = [
    'Sector (key)',
    'Sector (label)',
    'Section (key)',
    'Section (label)',
    'Question (key)',
    'Question (label)',
    'Field (key)',
    'Field (label)',
    'Field (type)',
    'Field (values)',
  ];

  // Convert the data structure into rows for the Excel file
  const rows: any[] = [headers];
  data.forEach((sector) => {
    sector.sections.forEach((section) => {
      section.questions.forEach((question) => {
        question.fields.forEach((field) => {
          rows.push([
            sector.sectorKey,
            sector.sectorLabel,
            section.sectionKey,
            section.sectionLabel,
            question.key,
            question.label,
            field.key,
            field.label,
            field.type,
            field.values,
          ]);
        });
      });
    });
  });

  // Create a worksheet from the rows data
  const ws = XLSX.utils.aoa_to_sheet(rows);

  // set cell widths
  const DEFAULT_CELL_WIDTH = 20;
  ws['!cols'] = [
    { wch: DEFAULT_CELL_WIDTH - 10 }, // Sector Key
    { wch: DEFAULT_CELL_WIDTH - 10 }, // Sector Label
    { wch: DEFAULT_CELL_WIDTH }, // Section Key
    { wch: DEFAULT_CELL_WIDTH }, // Section Label
    { wch: DEFAULT_CELL_WIDTH }, // Question Key
    { wch: DEFAULT_CELL_WIDTH }, // Question Label
    { wch: DEFAULT_CELL_WIDTH }, // Field Key
    { wch: DEFAULT_CELL_WIDTH }, // Field Label
    { wch: DEFAULT_CELL_WIDTH }, // Field Type
    { wch: DEFAULT_CELL_WIDTH }, // Field Values
  ];

  // merge cells
  const merges: XLSX.Range[] = [];
  let currentRow = 1; // row 0 is headers
  data.forEach((sector) => {
    const sectorStartRow = currentRow;
    sector.sections.forEach((section) => {
      const sectionStartRow = currentRow;
      section.questions.forEach((question) => {
        const questionStartRow = currentRow;
        question.fields.forEach((field) => {
          currentRow++;
        });
        // Merge Question columns if multiple fields
        if (currentRow - questionStartRow > 1) {
          merges.push(
            {
              s: { r: questionStartRow, c: 4 },
              e: { r: currentRow - 1, c: 4 },
            },
            {
              s: { r: questionStartRow, c: 5 },
              e: { r: currentRow - 1, c: 5 },
            },
          );
        }
      });
      // Merge Section columns
      if (currentRow - sectionStartRow > 1) {
        merges.push(
          { s: { r: sectionStartRow, c: 2 }, e: { r: currentRow - 1, c: 2 } },
          { s: { r: sectionStartRow, c: 3 }, e: { r: currentRow - 1, c: 3 } },
        );
      }
    });
    // Merge Sector columns
    if (currentRow - sectorStartRow > 1) {
      merges.push(
        { s: { r: sectorStartRow, c: 0 }, e: { r: currentRow - 1, c: 0 } },
        { s: { r: sectorStartRow, c: 1 }, e: { r: currentRow - 1, c: 1 } },
      );
    }
  });
  ws['!merges'] = merges;

  // Create a new workbook and append the worksheet
  const wb = XLSX.utils.book_new();
  const sheetName = 'CO2 Festivals Questions';
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // Write the Excel file
  const filename = 'fairly-score-festival-co2-questions.xlsx';
  XLSX.writeFile(wb, filename);
}
